module.exports = __webpack_public_path__ + "static/media/QRCode.edbf9a8f.png";